import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmailSendersComponent } from './email-senders.component';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { MatCardModule } from '@angular/material/card';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatTabsModule } from '@angular/material/tabs';
import { DomainRecordsComponent } from './domain-records/domain-records.component';
import { PendingChangesGuard } from '../../../core/pending-changes.guard';
import { SenderStatusComponent } from './sender-status.component';
import { SenderChooserComponent } from '@galaxy/email-ui/sender-chooser';

@NgModule({
  declarations: [EmailSendersComponent],
  imports: [
    CommonModule,
    GalaxyPageModule,
    GalaxyAlertModule,
    MatCardModule,
    MatTabsModule,
    DomainRecordsComponent,
    SenderStatusComponent,
    SenderChooserComponent,
  ],
  providers: [PendingChangesGuard],
})
export class EmailSendersModule {}
